<ngx-spinner
  [name]="appSpinnerName"
  bdColor="#00000000"
  size="medium"
  color="#0084d1"
  type="line-scale"
  [fullScreen]="true"
  [disableAnimation]="true"
>
  <div data-cy="loadingSpinner"></div>
</ngx-spinner>

<router-outlet></router-outlet>

<div *ngIf="routerEvents$ | async"></div>
